{
  "subscription": {
    "title": "I nostri articoli",
    "tag": "blog",
    "description": "Qui puoi trovare articoli dedicati alle energie rinnovabili, alla sostenibilità e alle ultime notizie del settore."
  },
  "subscription-form": {
    "submit": "Iscriviti",
    "placeholder": "nome.cognome@dominio.com",
    "terms": "Acconsento a ricevere newsletter ed email promozionali.",
    "success": "Iscrizione completata!",
    "error": "Si è verificato un errore. Riprova.",
    "fields": {
      "email": {
        "label": "Indirizzo email",
        "error": "Per favore inserisci un indirizzo email valido."
      },
      "terms": {
        "error": "Devi accettare i termini per procedere."
      }
    }
  },
  "backToBlog": "← Torna al blog"
}
